import { useState, useCallback, useRef, useEffect } from "react";
import CryptoJS from "crypto-js";
import { formatSqlEditor } from "../utils/formatting/formatSqlMulti";
import { SECRET_KEY } from "../constants";
import type { Task } from "../types";

export const useSqlQuery = (sql: string, setSql: (sql: string) => void, task: Task | null) => {
  const [toast, setToast] = useState<string | null>(null);
  const toastTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, []);

  const showToast = useCallback((message: string) => {
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
    }
    setToast(message);
    toastTimeoutRef.current = setTimeout(() => {
      setToast(null);
      toastTimeoutRef.current = null;
    }, 2500);
  }, []);

  const formatSql = useCallback(() => {
    try {
      const formatted = formatSqlEditor(sql);
      setSql(formatted);
      showToast("SQL форматирован!");
    } catch {
      showToast("Ошибка форматирования");
    }
  }, [sql, setSql, showToast]);

  const saveQuery = useCallback(async () => {
    if (!task) return;
    try {
      const compactSql = sql.trim();
      const encrypted = CryptoJS.AES.encrypt(compactSql, SECRET_KEY).toString();
      const encoded = encodeURIComponent(encrypted);
      const longUrl = `${window.location.origin}/task/${task.id}?query=${encoded}`;
      await navigator.clipboard.writeText(longUrl);
      showToast("Ссылка скопирована!");
    } catch {
      showToast("Не удалось скопировать ссылку");
    }
  }, [sql, task, showToast]);

  const shareQuery = useCallback(async () => {
    try {
      const compactSql = sql.trim();
      if (!compactSql) {
        showToast("Нет запроса для копирования");
        return;
      }
      const encrypted = CryptoJS.AES.encrypt(compactSql, SECRET_KEY).toString();
      const encoded = encodeURIComponent(encrypted);
      const longUrl = `${window.location.origin}/sandbox?query=${encoded}`;
      await navigator.clipboard.writeText(longUrl);
      showToast("Ссылка скопирована!");
    } catch {
      showToast("Не удалось скопировать ссылку");
    }
  }, [sql, showToast]);

  return { formatSql, saveQuery, shareQuery, toast };
};

